import { fetchData } from "app/services/apiService";

export const caricaAslTypeahed = (contiene, idcomuneResidenza) => {
    const apiUrl = `Asl/ElencoAslTypeahead/${contiene}/${idcomuneResidenza}`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };
}

export const caricaAslTypeahed2 = (contiene) => {
    const apiUrl = `Asl/ElencoAslTypeahead/${contiene}/${0}`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };
}

export const caricaAslDaComune = (idcomuneResidenza) => {
    const apiUrl = `Asl/ElencoAslDaComune/${idcomuneResidenza}`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };
}

export const getAslDaCodiceProvincia = (codAsl, provAssistito) => {
    const apiUrl = `Asl/GetAslDaCodiceProvincia/${codAsl}/${provAssistito}`;
    return (dispatch) => {
        return dispatch(fetchData(apiUrl))
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.log("errore", error);
                return Promise.reject(error);
            });
    };
}